jQuery(document).ready(function () {
    const opinionBoxContainer = document.querySelector('.opinion-box-container');
    const opinionBoxBtn = document.querySelectorAll('.opinion-box button');
    const opinionBox = document.querySelectorAll('.opinion-box');
    const opinionParas = document.querySelectorAll('.content-container__content p');
    const opinionsArray = [];

    for (let i = 0; i < opinionParas.length; i++) {
        let elHeight = getComputedStyle(opinionParas[i]).height;
        if(parseInt(elHeight) < 37) {
            opinionParas[i].classList.add('non-expanding');
        }
        opinionsArray.push(elHeight);
    }

    if(opinionsArray.length > 0) {
        opinionParas.forEach(el => el.classList.add('hidden-content'));

        opinionBoxBtn.forEach(el => el.addEventListener('click', () => {
            opinionBox.forEach(el => el.style.display = 'none');
        }));

        opinionBox.forEach((el, i) => el.addEventListener('mouseenter', () => {
            el.querySelector('.content-container__content p').classList.remove('hidden-content');
            el.querySelector('.content-container__content p').style.height = opinionsArray[i];
            clearInterval(interval);
        }));

        opinionBox.forEach(el => el.addEventListener('mouseleave', () => {
            el.querySelector('.content-container__content p').style.height = '';
            el.querySelector('.content-container__content p').classList.add('hidden-content');
            interval = setInterval(changeSlides, 3500);
        }));

        const firstSection = document.querySelector('section');
        const carousel = document.querySelector('.carousel-blog');
        const meetTeam = document.querySelector('.meet-team-to-project');

        const obsCallback = function (entries, observer) {
            entries.forEach(entry => {
                if(entry.intersectionRect.bottom < 250) {
                    opinionBoxContainer.classList.add('hidden');
                } else {
                    opinionBoxContainer.classList.remove('hidden');
                }
            });
        };

        const options = {
            root: null,
            threshold: 0.5,
        }

        // const observer = new IntersectionObserver(obsCallback, options);
        // const observer2 = new IntersectionObserver(obsCallback, options);
        const observer3 = new IntersectionObserver(obsCallback, options);

        // observer.observe(firstSection);
        // observer2.observe(carousel);
        observer3.observe(meetTeam);

        var swiperOpinions = new Swiper('.opinion-box-super-container', {
            freeMode: false,
            freeModeMomentum: false,
            watchSlidesVisibility: true,
            slidesPerView: 1,
            centeredSlides: false,
            mousewheel: {
                forceToAxis: true,
                invert: true
            },
            width: 385,
            breakpoints: {
                2560: {
                    slidesPerView: 1,
                },
                1600: {
                    width: 468,
                },
            },
        });

        let slide = 1;
        let activeSlide = 0;
        function changeSlides() {
            if(swiperOpinions.activeIndex === opinionBox.length - 1) {
                slide = -1;
            } else if(swiperOpinions.activeIndex === 0) {
                slide = 1;
            }
            activeSlide += slide;
            for (const opinionBoxEl of opinionBox) {
                opinionBoxEl.classList.remove('opinion-box--active');
            }
            opinionBox[activeSlide].classList.add('opinion-box--active');
            swiperOpinions.slideTo(swiperOpinions.activeIndex + slide);
        }

        let interval = setInterval(changeSlides, 3500);
    }
})